<template>
  <div></div>
</template>

<script>
export default {
  name: 'top0-9',
  props: {
    popList: Array
  },
  data () {
    return {
    }
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/main/top09.vue